














































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {NormativPotrosnjeGoriva, Vozilo} from "@/services/BackendProxies";
import {State} from "vuex-class";
import {TabBase} from "@/views/Vozila/PodaciVozila/TabBase";
import dataProxy from '@/services/data-proxy.service';

@Component({})
export default class Tab2 extends TabBase {
    @State vozilo!: Vozilo;
    normativ: NormativPotrosnjeGoriva[] = [];

    async handleSave() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            await this.save();
            await dataProxy.sacuvajNormativPotrosnjeGoriva(this.vozilo.id, this.normativ);
        }
    }

    @Watch('vozilo') async onVoziloChanged(vozilo:Vozilo) {
        this.normativ = await dataProxy.vratiNormativPotrosnjeGoriva(vozilo.id || 0);
    }
}
